<div class="title-block">
  <div class="page-title">{{title}}</div>
  <div [hidden]="isHidden" class="mark">#</div>
  <div [hidden]="isHidden" class="observation-id">{{id}}</div>
</div>
